import React, { Children, useState, useEffect } from "react";
import styles from "./Tabs.module.scss";

const Tabs = ({
  children,
  tabButtonStyle,
  buttonStyles,
  tabStyles,
  overflowScroll = false,
  initialTab = 0,
  onTabChange = () => {
    return;
  },
}) => {
  const [flattenedChildren, setFlattenedChildren] = useState(
    Children.toArray(children)
  );
  const [activeTabIndex, setActiveTabIndex] = useState(initialTab);
  const [activeTab, setActiveTab] = useState(children[initialTab]);

  useEffect(() => {
    setFlattenedChildren(() => [...Children.toArray(children)]);
  }, [children]);

  useEffect(() => {
    setActiveTab(flattenedChildren[activeTabIndex]);
  }, [activeTabIndex, flattenedChildren]);

  const handleTabButtonClick = (event, index) => {
    setActiveTabIndex(index);

    onTabChange(event, index);
  };

  const tabButtons = flattenedChildren.map((tab, index) => {
    const tabProps = tab?.props;

    return (
      <button
        type="button"
        key={index}
        data-title={tabProps?.title}
        className={`${styles.tabButton} ${styles[tabButtonStyle]} ${
          activeTabIndex === index ? styles.activeTabButton : ""
        }`}
        onClick={(event) => {
          handleTabButtonClick(event, index);
          if (tabProps?.onClick) {
            tabProps.onClick(event);
          }
        }}
      >
        <span className={`${styles.tabButtonTitle}`}>{tabProps.title}</span>
      </button>
    );
  });
  return (
    <div
      className={`${styles.tabContainer}`}
      style={{ overflow: overflowScroll ? "auto" : "hidden" }}
    >
      <div className={`${styles.tabButtons}`} style={buttonStyles}>
        {tabButtons}
      </div>
      <div className={`${styles.activeTabContent}`} style={tabStyles}>
        {activeTab}
      </div>
    </div>
  );
};

export default Tabs;
